import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {useEffect, useMemo, useState, useRef} from 'react'
import {
  fetchData,
  fetchFormData,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
  buildDropdownAudit,
} from '../../../reusable'
import Select from 'react-select'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'

import 'react-datepicker/dist/react-datepicker.css'
import {Link} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import Swal from 'sweetalert2'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faTrash, faSave} from '@fortawesome/free-solid-svg-icons'
import {Tr} from '../../../_metronic/i18n/Tr'

const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

const Popup = (props: any) => {
  let t = Tr()
  
  const [enName, setEnName] = useState('')
  const [ruName, setRuName] = useState('')
  const [uzName, setUzName] = useState('')
  const [categoryId, setCategoryId] = useState(null)
  const [error, setError] = useState(Object)
  const [image, setImage] = useState()
  const [imageUrl, setImageUrl] = useState('')
  const [addloader, setaddLoader] = useState(false)
  const [disable, setDisable] = useState(false)
  const [categoryList, setCategoryList] = useState([])
  const [oldCategoryId, setOldCategoryId] = useState(null)

  const savesubcategory = async () => {
    setDisable(true)

    let param = new FormData()
    param.append('enName', enName.trim())
    param.append('ruName', ruName != null ? ruName.trim() : '')
    param.append('uzName', uzName != null ? uzName.trim() : '')
    param.append('categoryId', categoryId ? categoryId['value'] : '')
    param.append('adminId', adminId)
    param.append('labels', buildDropdownAudit({ categoryId: { old: oldCategoryId, new: categoryId } }))

    
    if (image != null && image != undefined) {
      param.append('image', image ? image : '')
    }
    if (props.subcategoryid != '' && props.subcategoryid != null && props.subcategoryid > 0) {
      param.append('id', props.subcategoryid)
    }


    var res = await fetchFormData('admin/addeditsubcategory', param)
    if (res.status == '200') {
      if (props.subcategoryid !== '' && props.subcategoryid !== null && props.subcategoryid > 0) {
        toastsuccessmsg('Subcategory Updated Successfully')
      } else {
        toastsuccessmsg('Subcategory Added Successfully')
      }
      setDisable(false)
      props.onHide()
    } else {
      setDisable(false)
      toasterrormsg(res.message)
    }
  }
  const validate = () => {
    var errotmp: any = {}
    var err = 0
    if (enName.trim() == '' || enName.trim() == null || enName.trim() == undefined) {
      errotmp['enNameError'] = t('Subcategory English Name Is Required')
      err = 1
    } else if (enName.trim().length > 50) {
      errotmp['enNameError'] = t('Subcategory English Name Is Too Large')
      err = 1
    }
    if (ruName != null && ruName.trim().length > 50) {
      errotmp['ruNameError'] = t('Subcategory russian Name Is Too Large')
      err = 1
    }
    if (uzName != null && uzName.trim().length > 50) {
      errotmp['uzNameError'] = t('Subcategory Uzbek Name Is Too Large')
      err = 1
    }

    if (
      categoryId == null ||
      categoryId['value'] == undefined ||
      categoryId['value'] == null ||
      categoryId['value'] == ''
    ) {
      errotmp['categoryError'] = t('Category Is Required')
      err = 1
    }

    if (
      (image == null || image == undefined) &&
      (imageUrl == '' || imageUrl == null || imageUrl == undefined)
    ) {
      errotmp['imageError'] = t('Subcategory Image Is Required')
      err = 1
    }
    setError(errotmp)
    if (err == 0) {
      savesubcategory()
    }
  }
  const subcategorydetail = async (catlist: any) => {
    setaddLoader(true)
    var param = {
      subcategoryId: props.subcategoryid,
    }
    var res = await fetchData('admin/subcategorydetail', param)
    if (res.status == '200') {
      var data = res.data[0]

      setImageUrl(data.image)
      setEnName(data.en_name)
      setRuName(data.ru_name)
      setUzName(data.uz_name)

      if (data.categoryId > 0) {
        var tmp: any = catlist.filter((item: any) => item.value == data.categoryId)
        setCategoryId(tmp[0])
        setOldCategoryId(tmp[0])
      }

      setaddLoader(false)
    } else {
      setaddLoader(false)
      toasterrormsg(res.message)
    }
  }
  const categorylistapicall = async () => {
    var param: any = {}

    var response: any = await fetchData('admin/categorylist', param)

    if (response.status == '200') {
      var tmp: any = response.data.map((item: any) => {
        return {value: item.categoryId, label: item.en_name}
      })
      setCategoryList(tmp)
      if (props.subcategoryid > 0) {
        subcategorydetail(tmp)
      }
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    categorylistapicall()
  }, [])

  // add / edit facility state end
  return (
    <Modal
      {...props}
      size='xl'
      aria-labelledby='contained-modal-title-hcenter'
      dialogClassName='maxwidth1000px'
      centered
      backdrop='static'
      keyboard={false}
    >
      <Modal.Header closeButton>
        <div className='d-flex align-items-center col-10'>
          <h4 className='fw-bold'>
            {categoryId !== '' && categoryId !== null && categoryId > 0 ? t('Edit') : t('Add')}{' '}
            {t('Category')}
          </h4>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div
          className='stepper stepper-links d-flex flex-column'
          id='kt_create_account_stepper'
          data-kt-stepper='true'
        >
          <div className='mx-auto mw-600px w-100 py-10' id='kt_create_account_form'>
            <div>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6 required'>
                  {t('Image')}
                </label>

                <div className='col-lg-8'>
                  <div className='image-input image-input-outline ' data-kt-image-input='true'>
                    <img
                      alt='images'
                      id='previewImage'
                      className='image-input-wrapper w-125px h-125px changeimg pointer'
                      src={
                        image
                          ? URL.createObjectURL(image)
                          : imageUrl === '' || imageUrl === null
                          ? toAbsoluteUrl('/media/default.jpg')
                          : imageUrl
                      }
                    />

                    <label
                      className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='change'
                      data-bs-toggle='tooltip'
                      title=''
                      data-bs-original-title='Change avatar'
                    >
                      <i className='fa fa-edit'></i>
                      <input
                        type='file'
                        name='image'
                        id='profileImage'
                        accept='.png, .jpg, .jpeg'
                        style={{display: 'none'}}
                        onChange={(e: any) => {
                          if (
                            e.target.files[0]['type'] != 'image/jpeg' &&
                            e.target.files[0]['type'] != 'image/jpg' &&
                            e.target.files[0]['type'] != 'image/png'
                          ) {
                            alert('Upload Only JPG, PNG Or PNG File')
                          } else if (e.target.files[0] != null && e.target.files[0] != undefined) {
                            setImage(e.target.files[0])
                          }
                        }}
                      />
                      <input type='hidden' name='avatar_remove' />
                    </label>
                  </div>

                  <div className='form-text' id='validimage'>
                    {t('Allowed file types: png, jpg, jpeg.')}
                  </div>
                  <label className='text-danger'>{error.imageError || ''}</label>
                </div>
              </div>
            </div>
            <div>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {t('Category')}{' '}
              </label>
              <Select
                options={categoryList}
                value={categoryId}
                placeholder={t('Select Category')}
                isMulti={false}
                onChange={(e: any) => {
                  setCategoryId(e)
                }}
              />
              <label className='text-danger'>{error.categoryError}</label>
            </div>
            <div>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {t('English Name')}
              </label>
              <input
                type='text'
                name='categoryname'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder={t('English Name')}
                value={enName}
                onChange={(e: any) => setEnName(e.target.value)}
              ></input>
              <label className='text-danger'>{error.enNameError || ''}</label>
            </div>
            <div>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>{t('Russian Name')}</label>
              <input
                type='text'
                name='categoryname'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder={t('Russian Name')}
                value={ruName}
                onChange={(e: any) => setRuName(e.target.value)}
              ></input>
              <label className='text-danger'>{error.ruNameError || ''}</label>
            </div>
            <div>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>{t('Uzbek Name')}</label>
              <input
                type='text'
                name='categoryname'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder={t('Uzbek Name')}
                value={uzName}
                onChange={(e: any) => setUzName(e.target.value)}
              ></input>
              <label className='text-danger'>{error.uzNameError || ''}</label>
            </div>

            {/* action button start */}
            <div className={`d-flex pt-15 justify-content-center`}>
              <button
                type='button'
                className={`btn btn-lg btn-light-success me-3`}
                onClick={props.onHide}
              >
                {t('Cancel')}
              </button>

              <button
                type='button'
                disabled={disable}
                className={`btn btn-lg btn-success monthBtn me-3`}
                onClick={() => validate()}
              >
                {!disable && t('Save')}
                {disable && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {t('Please wait...')}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

function SubcategoryPage() {
  let t = Tr()
  const {menuId, menuIdAdd, menuIdDelete, menuIdEdit} = useMenuIdPermissions()

  const [showPopup, setShowPopup] = useState(false)
  const [subcategoryList, setSubcategoryList] = useState([])
  const [orgsubcategoryList, setOrgSubcategoryList] = useState([])
  const [subcategoryId, setSubcategoryId] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)
  const [orderMap, setOrderMap] = useState<Record<number, number>>({})
  const [savingOrder, setSavingOrder] = useState(false)

  const getEffectiveOrder = (row: any) => {
    return orderMap[row.subcategoryId] !== undefined ? orderMap[row.subcategoryId] : (row.order || 0)
  }

  const handleOrderChange = (subcatId: number, categoryIdOfRow: number, value: string) => {
    const newOrder = parseInt(value, 10)
    if (isNaN(newOrder) || newOrder < 0) return

    const currentRow: any = orgsubcategoryList.find((item: any) => item.subcategoryId === subcatId)
    if (!currentRow) return

    const oldOrder = getEffectiveOrder(currentRow)

    // Find the other subcategory in the same category that already has this order
    const conflictRow: any = orgsubcategoryList.find(
      (item: any) =>
        item.categoryId === categoryIdOfRow &&
        item.subcategoryId !== subcatId &&
        getEffectiveOrder(item) === newOrder
    )

    setOrderMap((prev) => {
      const updated = {...prev, [subcatId]: newOrder}
      // Swap: give the conflicting item the old order of the changed item
      if (conflictRow) {
        updated[conflictRow.subcategoryId] = oldOrder
      }
      return updated
    })
  }

  const saveSubcategoryOrder = async () => {
    const entries = Object.entries(orderMap)
    if (entries.length === 0) {
      toasterrormsg('No order changes to save')
      return
    }
    setSavingOrder(true)
    try {
      const param = {
        adminId: adminId,
        response: entries.map(([id, order]) => {
          const row: any = orgsubcategoryList.find((item: any) => item.subcategoryId == id)
          return {
            subcategoryId: Number(id),
            order: order,
            oldOrder: row?.order || 0,
            en_name: row?.en_name || '',
            categoryname: row?.categoryname || '',
          }
        }),
      }
      const response: any = await fetchData('admin/updatesubcategoryorder', param)
      if (response.status == '200') {
        toastsuccessmsg(response.message || 'Subcategory Order Updated Successfully')
        setOrderMap({})
        subcategorylistapicall()
      } else {
        toasterrormsg(response.message || 'Failed to update order')
      }
    } catch (error) {
      toasterrormsg('An error occurred while updating order')
    }
    setSavingOrder(false)
  }

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('Image'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5 d-flex align-items-center justify-content-center'>
              <img className='w-50px h-50px' src={row.image} alt='images' />
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
      },
      {
        name: t('English Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.en_name}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.en_name),
      },
      {
        name: t('Russian Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.ru_name}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.ru_name),
        filter: true,
      },
      {
        name: t('Uzbek Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.uz_name}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.uz_name),
        filter: true,
      },
      {
        name: t('Category Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.categoryname}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.categoryname),
        filter: true,
      },
      {
        name: t('Order'),
        width: '100px',
        cell: (row: any) => (
          <input
            type='number'
            className='form-control form-control-sm w-70px'
            value={orderMap[row.subcategoryId] !== undefined ? orderMap[row.subcategoryId] : (row.order || '')}
            onChange={(e: any) => handleOrderChange(row.subcategoryId, row.categoryId, e.target.value)}
            min={0}
          />
        ),
        sortable: true,
        selector: (row: any) => row.order || 0,
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {menuIdAdd ? (
              <button
                className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
                title='Edit'
                onClick={() => {
                  setShowPopup(true)
                  setSubcategoryId(row.subcategoryId)
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            ) : (
              ''
            )}

            {menuIdDelete ? (
              <button
                className='btn btn-icon btn-wave waves-effect waves-light btn-sm btn-primary-light me-2'
                title='delete'
                onClick={() => deletesubcategory(row.subcategoryId)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            ) : (
              ''
            )}
          </>
        ),
      },
    ],
    [t]
  )

  const deletesubcategory = async (subcategoryId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete This Subcategory!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'), // Custom OK button text
      cancelButtonText: t('Cancel'), // Custom Cancel button text
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          var param: any = {
            id: String(subcategoryId),
            adminId: adminId
          }

          const response = await fetchData('admin/deletesubcategory', param)

          if (response.status == '200') {
            toastsuccessmsg(response.message)
            subcategorylistapicall()
          } else {
            toasterrormsg(response.message)
          }
        } catch (error) {
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  // call category list api
  const subcategorylistapicall = async () => {
    var param: any = {}
    var response: any = await fetchData('admin/subcategorylist', param)

    if (response.status == '200') {
      setSubcategoryList(response.data)
      setOrgSubcategoryList(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Subcategory'
    subcategorylistapicall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Subcategory')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8 gap-2' data-kt-user-table-toolbar='base'>
          {menuIdEdit && Object.keys(orderMap).length > 0 ? (
            <button
              type='button'
              className='btn btn-primary'
              onClick={saveSubcategoryOrder}
              disabled={savingOrder}
            >
              <FontAwesomeIcon icon={faSave} className='me-2' />
              {savingOrder ? t('Saving...') : t('Save Order')}
            </button>
          ) : (
            ''
          )}
          {menuIdAdd ? (
            <button type='button' className='btn btn-success' onClick={() => setShowPopup(true)}>
              <KTIcon iconName='plus' className='fs-2' />
              {t('Add Subcategory')}
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    )
  }

  //search function
  const categorysearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setSubcategoryList(orgsubcategoryList)
    } else {
      var tmp: any = orgsubcategoryList.filter(
        (item: any) =>
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase() == text.toLowerCase()) ||
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.ru_name != null && item.ru_name != '' && item.ru_name == text) ||
          (item.ru_name != null && item.ru_name != '' && item.ru_name.includes(text)) ||
          (item.uz_name != null && item.uz_name != '' && item.uz_name == text) ||
          (item.uz_name != null && item.uz_name != '' && item.uz_name.includes(text)) ||
          (item.categoryname != null &&
            item.categoryname != '' &&
            item.categoryname.toLowerCase() == text.toLowerCase()) ||
          (item.categoryname != null &&
            item.categoryname != '' &&
            item.categoryname.toLowerCase().includes(text.toLowerCase()))
      )

      setSubcategoryList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgsubcategoryList.length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={subcategoryList}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader search={searchTerm} isfoc={focus} customSearch={categorysearch} />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column mt-10 pt-20 pb-2 mb-2'>
                    <h2 className='fs-2x fw-bold '>{t('Welcome To Subcategory')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold'>{t('There are no Subcategory')}</p>
                  {menuIdAdd ? (
                    <Link
                      to='#'
                      className='btn btn-success monthBtn'
                      onClick={() => setShowPopup(true)}
                    >
                      {t('Add Subcategory')}
                    </Link>
                  ) : (
                    ''
                  )}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <Popup
            show={showPopup}
            onHide={() => {
              setShowPopup(false)
              subcategorylistapicall()

              setSubcategoryId(0)
            }}
            subcategoryid={subcategoryId}
          />
        )}
      </div>
    </>
  )
}

export default SubcategoryPage
